import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { Step } from './styles';
import { getStatus } from './utils';

export default function Steps({ stepNames, currentStepIndex, currentStep }) {
  const indexOfCurrentStep =
    typeof currentStepIndex === 'number' ? currentStepIndex : stepNames.indexOf(currentStep);

  return (
    <Stack
      direction="row"
      padding="0px 16px"
      role="list"
      spacing="2px"
    >
      {stepNames.map((stepName, index) => {
        const status = getStatus(index, indexOfCurrentStep);
        return (
          <Step
            key={stepName}
            role="listitem"
            status={status}
          />
        );
      })}
    </Stack>
  );
}

Steps.propTypes = {
  stepNames: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    .isRequired,
  currentStep: PropTypes.string,
  currentStepIndex: PropTypes.number
};
